import { MutationTree } from 'vuex';

export default <MutationTree<attendance.state.AttendanceState>>{};
